import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
import common from "./modules/common";
import goods from "./modules/goods";

export default new Vuex.Store({
  modules: {
    common,
    goods,
  },
  plugins: [
    createPersistedState({
      reducer(val) {
        return {
          // 存在localstorage中的值
          common: val.common,
          goods: val.goods
        };
      }
    })
  ]
});
